module.exports = __webpack_public_path__ + "static/media/completion.496c228a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reportcentre/completion.jpg
// module id = 2935
// module chunks = 0